export const apiRoute = "https://portal.daleoperating.com/wp-json";



// WEBPACK FOOTER //
// ./src/utils/api.js